import { fixBody, unfixBody } from "./fixBody";

const MainNavigation = function (settings) {
	"use strict";

	const _self = this;
	const _settings = {
		open: false,
	};

	Object.assign(_settings, settings);

	function cacheDom() {
		_settings.$el = document.querySelector(_settings.el);
		_settings.$navigationContainer = _settings.$el.querySelector(
			_settings.navigationContainer
		);
		_settings.$toggleContainer = _settings.$el.querySelector(
			_settings.toggleContainer
		);
		_settings.$toggleButton = _settings.$el.querySelector(
			_settings.toggleButton
		);
		_settings.$links = _settings.$navigationContainer.querySelectorAll("a");
	}

	function bindEvents() {
		_settings.$toggleButton.addEventListener("click", handleToggle);
		_settings.$links.forEach((el) => {
			el.addEventListener("click", hideMenu);
		});
	}

	function handleToggle(e) {
		e.preventDefault();

		if (_settings.open) {
			hideMenu();
		} else {
			showMenu();
		}
	}

	function showMenu() {
		fixBody();

		_settings.$toggleContainer.classList.add(_settings.toggleActiveClass);
		_settings.$navigationContainer.classList.add(
			_settings.navigationActiveClass
		);
		_settings.open = true;
	}

	function hideMenu() {
		unfixBody();

		_settings.$toggleContainer.classList.remove(_settings.toggleActiveClass);
		_settings.$navigationContainer.classList.remove(
			_settings.navigationActiveClass
		);
		_settings.open = false;
	}

	function init() {
		cacheDom();
		bindEvents();

		return _self;
	}

	return init();
};

export { MainNavigation };
